import { RotateImageBodyRequest, RotateImageRequest } from '@eigtech/documents-types'
import type { MarkNoteForPublicationResponse } from '@eigtech/notes-types'
import { getResourceId } from '@eigtech/shared-corn'
import { contextualPut, useMutation } from '@eigtech/ui-shared-api'
import { documentsBasePath } from './constants'
import { useInvalidateDocumentUrl } from './getDocumentUrl'

const rotateImage = ({ documentCorn, entityId, ...payload }: RotateImageRequest) =>
  contextualPut<MarkNoteForPublicationResponse, RotateImageBodyRequest>(
    `${documentsBasePath}/${entityId}/${documentCorn}/rotate`,
    payload,
    { responseType: 'none' }
  )

export function useRotateImage() {
  const invalidateDocumentUrl = useInvalidateDocumentUrl()

  return useMutation({
    mutationKey: ['rotateImage'],
    mutationFn: rotateImage,
    onSuccess(__, { entityId, documentCorn }) {
      invalidateDocumentUrl({ entityId, documentId: getResourceId(documentCorn) })
    },
  })
}
